// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.4.205",
  "gitHash": "56934b7cccb68afac08815e2252fb05221eaa92c",
  "versionWithHash": "5.4.205-56934b7cccb68afac08815e2252fb05221eaa92c"
};
